import { MicroFrontendConfigs } from '@cko/dashboard-shared';

import { Mfe } from '../../config/shared/enums/mfeTeam';

const REMOTE_ENTRY_SUFFIX = '/remoteEntry.js';

type NormalizedMicroFrontendConfig = {
  base: string;
  name: string;
};

export const matchMfesFromStackTrace = (
  stackTrace: string | undefined,
  mfeConfigs: MicroFrontendConfigs,
): string[] => {
  if (!stackTrace) {
    return [Mfe.DASHBOARD_APP];
  }

  const normalisedMfeConfigs: NormalizedMicroFrontendConfig[] = Object.entries(mfeConfigs).reduce<
    NormalizedMicroFrontendConfig[]
  >((configs, [name, { entry_point: entryPoint }]) => {
    const strippedEntryPoint = entryPoint
      .replace(/^https?:\/\//, '')
      .replace(REMOTE_ENTRY_SUFFIX, '');
    if (!strippedEntryPoint) {
      return configs;
    }

    return [
      ...configs,
      {
        name,
        base: strippedEntryPoint,
      },
    ];
  }, []);

  const urlRegex = /(?:https?:\/\/)([\w.-]+(?:\/[\w./-]+)?)/g;
  const matchedMfes = new Set<string>();

  let match;
  while ((match = urlRegex.exec(stackTrace)) !== null) {
    const path = match[1];

    for (const { name, base } of normalisedMfeConfigs) {
      if (path.includes(base)) {
        matchedMfes.add(name);
      }
    }
  }

  if (matchedMfes.size === 0) {
    return [Mfe.DASHBOARD_APP];
  }

  return [...matchedMfes];
};

const CHROME_EXTENSION_ERROR_PREFIX = 'chrome-extension://';

export const isBrowserExtensionError = (stackTrace: string) => {
  return stackTrace.includes(CHROME_EXTENSION_ERROR_PREFIX);
};
